export const individualTizerIds = ['catalog1', 'catalog2', 'catalog3'];
export const businessTizerIds = [
  'catalog_bsns1',
  'catalog_bsns2',
  'catalog_bsns3',
];
